import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
declare let $: any;

@Component({
  selector: 'app-affaires-facturations',
  templateUrl: './affaires-facturations.component.html',
  styleUrls: ['./affaires-facturations.component.css'],
  standalone: false
})
export class AffairesFacturationsComponent implements OnInit {
  accountNumber: any;
  sigle: string;
  facturations: any[] = [];
  allFacturations: any[] = [];
  monthOptions: { value: string; label: string }[] = [];
  selectedMonth: string;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  error: boolean;
  succes: boolean;
  transfert: boolean = false;
  notTranfering: boolean;
  pay: boolean = false;
  bDescription: string;
  safeName: string;
  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.routerActivate.params.subscribe(params => {
      this.accountNumber = params['id']
    });
    this.sigle = localStorage.getItem('sigle');
    const raw = localStorage.getItem("bDescription");
    this.bDescription = raw ? decodeURIComponent(raw) : '';
    this.safeName = encodeURIComponent(this.bDescription);
    this.getFacturations();
  }
  getFacturations() {
    this.userService.getUtilisateursBaccountFacturation(this.accountNumber).subscribe((data: any[]) => {
      this.allFacturations = data || [];
      this.buildMonthOptions();
      this.applyMonthFilter(this.selectedMonth);
    })
  }



  changeTarif(id, typ) {
    this.userService.updateFacturation(id, typ).subscribe(data => {
      if (data == 0) {
        this.succes = true;
        setTimeout(() => {
          this.getFacturations();
          this.succes = false;
        }, 3000);
      }
      else {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
      }
    })

  }

  makeTransfert(id) {

    this.userService.transfertMensualite(id, this.accountNumber).subscribe(data => {

      if (data == 0) {
        this.transfert = true;
        setTimeout(() => {

          this.transfert = false
          this.getFacturations();
        }, 3000);
      }
      else if (data == -1) {
        this.notTranfering = true;
        setTimeout(() => {
          this.notTranfering = false;
        }, 3000);
      }
      else {
        this.pay = true;
        setTimeout(() => {
        this.pay = false;
      }, 3000);

    }
  })
  }

  applyMonthFilter(monthKey: string) {
    this.selectedMonth = monthKey || this.getCurrentMonthKey();
    this.facturations = this.allFacturations.filter(f => this.getMonthKeyFromParts(f?.annee, f?.month) === this.selectedMonth);
  }

  private buildMonthOptions() {
    const months = new Set<string>();
    const current = this.getCurrentMonthKey();
    months.add(current); // always include current month
    this.allFacturations.forEach(f => {
      const key = this.getMonthKeyFromParts(f?.annee, f?.month);
      if (key) { months.add(key); }
    });
    this.monthOptions = Array.from(months)
      .sort((a, b) => b.localeCompare(a)) // newest first
      .map(key => ({ value: key, label: this.formatMonthLabel(key) }));
    this.selectedMonth = current;
  }

  private getMonthKeyFromParts(year: any, month: any): string {
    if (year == null || month == null) { return ''; }
    const m = Number(month);
    const y = Number(year);
    if (isNaN(m) || isNaN(y)) { return ''; }
    const paddedMonth = String(m).padStart(2, '0');
    return `${y}-${paddedMonth}`;
  }

  private getCurrentMonthKey(): string {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${now.getFullYear()}-${month}`;
  }

  private formatMonthLabel(key: string): string {
    const [year, month] = key.split('-').map(Number);
    const d = new Date(year, (month || 1) - 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  }

}
